import { create } from 'zustand';
import type { StationFilters } from '@/types/domain';

interface UIState {
  // mobile bottom sheet
  bottomSheetOpen: boolean;
  setBottomSheetOpen: (open: boolean) => void;
  // mobile search overlay
  searchOverlayOpen: boolean;
  setSearchOverlayOpen: (open: boolean) => void;
  // station detail drawer (desktop) / expanded sheet (mobile)
  detailStationId: string | null;
  openDetail: (id: string) => void;
  closeDetail: () => void;
  // expanded full-screen player (mobile)
  playerExpanded: boolean;
  setPlayerExpanded: (open: boolean) => void;
  // filters
  filters: StationFilters;
  setFilter: <K extends keyof StationFilters>(
    key: K,
    value: StationFilters[K],
  ) => void;
  resetFilters: () => void;
}

const defaultFilters: StationFilters = {
  genre: null,
  language: null,
  countryCode: null,
  minBitrate: null,
  favoritesOnly: false,
  workingOnly: true,
  // The production app is served over HTTPS, so HTTP audio would be
  // blocked by browsers as mixed content.
  httpsOnly: true,
};

export const useUIStore = create<UIState>((set) => ({
  bottomSheetOpen: false,
  setBottomSheetOpen: (bottomSheetOpen) => set({ bottomSheetOpen }),
  searchOverlayOpen: false,
  setSearchOverlayOpen: (searchOverlayOpen) => set({ searchOverlayOpen }),
  detailStationId: null,
  openDetail: (id) => set({ detailStationId: id }),
  closeDetail: () => set({ detailStationId: null }),
  playerExpanded: false,
  setPlayerExpanded: (playerExpanded) => set({ playerExpanded }),
  filters: defaultFilters,
  setFilter: (key, value) =>
    set((s) => ({ filters: { ...s.filters, [key]: value } })),
  resetFilters: () => set({ filters: defaultFilters }),
}));
